/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import cn from 'clsx';
import { Form, Modal } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { getMomentDate } from 'util/date';
import debounce from 'lodash/debounce';
import { AModal, AButton } from 'components/Antd';
import { apiGetTestItemCitations } from 'api/shared';
import useCurrentUser from 'hooks/useCurrentUser';
import useUploadFile from 'modules/inspection/hooks/useUploadDocument';
import { apiAddServiceProvider } from 'api/qc-inspection';
import { ReactComponent as PlusCircleSvg } from 'assets/icons/New/FilterBar/PlusCircle.svg';
import { ReactComponent as LinkSvg } from 'assets/icons/New/Link.svg';
import { useCreate } from 'context/ResourceProvider/hooks/useCreate';
import useOptions from 'hooks/useOptions';
import { applySearch } from 'util/search';
import { ADD_CD_TAB_KEYS } from 'views/ProductDetail/Sections/QualityRequirement/components/AddCDModal/constants';
import T from 'i18n-react';
import Document from './Document';
import TestField from './TestField';
import CertificateField from './CertificateField';
import OtherField from './OtherField';
import AddExistingDocumentsModal from '../AddExistingDocumentsModal';
import classes from './AddDataModal.module.scss';

export const ADD_DATA_ACTIONS = {
  TEST_DATA: 'TEST_DATA',
  CERTIFICATE_DATA: 'CERTIFICATE_DATA',
  OTHER_DATA: 'OTHER_DATA',
};

let testItemId = '';
let citationId = '';

const AddDataModal = ({
  open,
  onClose,
  onSubmit,
  title,
  action,
  editObj,
  issuePartyOptions,
  existingDocuments,
  reloadIssuePartyOptions,
  complianceTypeOptions,
  reloadComplianceTypes,
  scoreOptions,
  reloadScoreOptions,
  otherComplianceTypeOptions,
  viewObj,
  entity = 'Product',
  hideDocument,
}) => {
  const { mutate: createTestItem } = useCreate({
    resource: 'test_items',
  });
  const { mutate: createComplianceType } = useCreate({
    resource: 'compliance-certificate-type',
  });
  const { mutate: createCustomOptions } = useCreate({
    resource: 'compliance-custom-options',
  });
  const me = useCurrentUser();
  const { uploadFile } = useUploadFile();
  const editAction = editObj?.action || '';
  const isDuplicate = editAction === 'duplicate';
  const isRenew = editAction === 'renew';
  const isEdit = editAction === 'edit';
  const isView = !!viewObj?.dataObj?.id;
  const viewAction = viewObj?.dataObj?.dataType;
  const inputFileRef = useRef(null);
  const [modal, contextHolder] = Modal.useModal();
  const [options, setOptions] = React.useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [isSelectExisting, setIsSelectExisting] = useState(false);
  const [loading, setLoading] = useState(false);
  const { countryListOptions } = useOptions();
  const [form] = Form.useForm();
  const exportMarketId = useWatch('exportMarket', form);
  const isPrepopulate = isEdit || isDuplicate || isRenew || isView;
  if (isView) {
    editObj.name = viewObj?.dataObj?.otherData?.name || '';
    editObj.description = viewObj?.dataObj?.otherData?.description || '';
    editObj.customCertificateScoreId =
      viewObj?.dataObj?.certificateData?.customCertificateScore?.name || null;
    editObj.certificateTypeId =
      viewObj?.dataObj?.certificateData?.certificateType?.name ||
      viewObj?.dataObj?.otherData?.customComplianceOtherDataType?.name ||
      null;
    editObj.result =
      viewObj?.dataObj?.testData?.result || viewObj?.dataObj?.otherData?.result || '';
    editObj.countryListId = viewObj?.dataObj?.testData?.countryList?.name || null;
    editObj.testItemId =
      [viewObj?.dataObj?.testData?.citation?.name, viewObj?.dataObj?.testData?.testItem?.name].join(
        ', '
      ) || null;
    editObj.reportId = viewObj?.dataObj?.testData?.reportId || '';
    editObj.serviceProviderId =
      viewObj?.dataObj?.testData?.serviceProvider?.name ||
      viewObj?.dataObj?.certificateData?.customIssueParty?.name ||
      viewObj?.dataObj?.otherData?.customIssueParty?.name ||
      null;
    editObj.expiryDate =
      viewObj?.dataObj?.testData?.expiryDate ||
      viewObj?.dataObj?.certificateData?.expiryDate ||
      viewObj?.dataObj?.otherData?.expiryDate ||
      '';
    editObj.documentLists =
      viewObj?.dataObj?.testData?.documentLists ||
      viewObj?.dataObj?.certificateData?.documentLists ||
      viewObj?.dataObj?.otherData?.documentLists ||
      [];
    editObj.testDate =
      viewObj?.dataObj?.testData?.testDate ||
      viewObj?.dataObj?.certificateData?.testDate ||
      viewObj?.dataObj?.otherData?.testDate ||
      undefined;
  }
  const isEditDocuments = editObj?.documentLists || [];
  const handleConfirm = ({ title, description, submitText }, cb) => {
    modal.confirm({
      title,
      icon: <></>,
      content: description,
      onOk() {
        if (cb) cb();
      },
      okText: submitText,
      closable: true,
      onCancel() {},
      centered: true,
      cancelButtonProps: {
        className: classes.cancelBtn,
      },
      className: classes.warningModal,
    });
  };
  const handleCreateIssueParty = async (newOption) => {
    try {
      form.setFieldValue(`issueParty`, newOption.value);
      const res = await createCustomOptions({
        name: newOption.value,
        type: 'issueParty',
      });
      reloadIssuePartyOptions(() => {
        if (res?.data?.data?.id) {
          form.setFieldValue('issueParty', res.data.data.id);
        }
      });
    } catch (error) {}
  };
  const handleCreateScore = async (newOption) => {
    try {
      form.setFieldValue(`score`, newOption.value);
      const res = await createCustomOptions({
        name: newOption.value,
        type: 'certificateScore',
      });
      reloadScoreOptions(() => {
        if (res?.data?.data?.id) {
          form.setFieldValue('score', res.data.data.id);
        }
      });
    } catch (error) {}
  };
  const handleCreateType = async (newOption) => {
    try {
      form.setFieldValue(`type`, newOption.value);
      let res = {};
      if (action === ADD_DATA_ACTIONS.OTHER_DATA) {
        res = await createCustomOptions({
          name: newOption.value,
          type: 'complianceOtherDataType',
        });
      } else {
        res = await createComplianceType({
          name: newOption.value,
        });
      }
      reloadComplianceTypes(() => {
        if (res?.data?.data?.id) {
          form.setFieldValue('type', res.data.data.id);
        }
      });
    } catch (error) {}
  };
  const onCreateTestItemOption = async (value) => {
    const response = await createTestItem({
      name: value,
      countryListId: exportMarketId,
    });
    loadTestItems(exportMarketId, '', () => {
      form.setFieldValue('testItem', response?.data?.data?.id);
      testItemId = response?.data?.data?.id;
      citationId = response?.data?.data?.citationListId;
    });
  };
  const loadTestItems = async (tId, tKeyword = '', cb) => {
    const result = await apiGetTestItemCitations({
      countryListId: tId,
      keyword: tKeyword,
    });
    setOptions(
      (result?.data?.data?.list || []).map((t) => ({
        value: t.id,
        label: [t.citationList?.name, t.name].filter((v) => !!v).join(', '),
        testItemId: t.id,
        citationId: t.citationList?.id,
        sourceType: t.sourceType,
      }))
    );
    if (cb) cb();
  };
  const handleDelete = (deleteType) => (obj) => {
    handleConfirm(
      {
        title: 'Are you sure to remove this document',
        description: 'The action cannot be undone.',
        submitText: 'Remove',
      },
      () => {
        if (deleteType === 'new') {
          setNewFiles((prev) => prev.filter((item) => item.id !== obj.id));
        } else {
          setExistingFiles((prev) => prev.filter((item) => String(item) !== String(obj.id)));
        }
      }
    );
  };
  const renderFields = () => {
    const tAction = isView ? viewAction : action;
    switch (tAction) {
      case ADD_CD_TAB_KEYS.TEST:
      case ADD_DATA_ACTIONS.TEST_DATA:
        return (
          <TestField
            disabled={isView}
            isRenew={isRenew}
            form={form}
            countryListOptions={countryListOptions}
            loadTestItems={loadTestItems}
            handleCreateIssueParty={handleCreateIssueParty}
            exportMarketId={exportMarketId}
            options={options}
            onTestItemChanged={(val, tOption) => {
              form.setFieldValue(`testItem`, val);
              testItemId = tOption?.testItemId;
              citationId = tOption?.citationId;
            }}
            onCreateTestItemOption={onCreateTestItemOption}
            onTestItemSearch={(val) => {
              if (val) {
                applySearch(val, (tVal) => {
                  loadTestItems(exportMarketId, tVal);
                });
              } else {
                loadTestItems(exportMarketId, '');
              }
            }}
            issuePartyOptions={issuePartyOptions}
            isShort={hideDocument}
          />
        );
      case ADD_CD_TAB_KEYS.CERTIFICATE:
      case ADD_DATA_ACTIONS.CERTIFICATE_DATA:
        return (
          <CertificateField
            disabled={isView}
            isRenew={isRenew}
            handleCreateType={handleCreateType}
            handleCreateIssueParty={handleCreateIssueParty}
            handleCreateScore={handleCreateScore}
            complianceTypeOptions={complianceTypeOptions}
            issuePartyOptions={issuePartyOptions}
            scoreOptions={scoreOptions}
            isShort={hideDocument}
          />
        );
      case ADD_CD_TAB_KEYS.OTHER:
      case ADD_DATA_ACTIONS.OTHER_DATA:
        return (
          <OtherField
            disabled={isView}
            isRenew={isRenew}
            handleCreateType={handleCreateType}
            handleCreateIssueParty={handleCreateIssueParty}
            complianceTypeOptions={otherComplianceTypeOptions}
            issuePartyOptions={issuePartyOptions}
            isShort={hideDocument}
          />
        );
      default:
        return '';
    }
  };

  useEffect(() => {
    if (isEdit || isDuplicate || isRenew || isView) {
      testItemId = editObj.testItemId;
      citationId = editObj.citationId;
      if (action === ADD_DATA_ACTIONS.TEST_DATA) {
        loadTestItems(editObj?.countryListId, '');
      }
      if (isDuplicate || isView) {
        setExistingFiles(isEditDocuments.map((obj) => obj.id));
      }
    } else {
      testItemId = '';
      citationId = '';
    }
  }, []);

  return (
    <>
      <AModal
        title={isRenew ? 'Renew Data' : title}
        open={open}
        onCancel={onClose}
        closable
        width={1100}
        className={cn(classes.modalWrapper)}>
        <Form
          name="setDataForm"
          initialValues={{
            name: isPrepopulate ? editObj?.name || '' : '',
            description: isPrepopulate ? editObj?.description || '' : '',
            score: isPrepopulate ? editObj?.customCertificateScoreId || null : null,
            type: isPrepopulate
              ? editObj?.certificateTypeId || editObj?.customComplianceOtherDataTypeId || null
              : null,
            testResult: isPrepopulate ? editObj?.result || '' : '',
            exportMarket: isPrepopulate ? editObj?.countryListId || null : null,
            testItem: isPrepopulate ? editObj?.testItemId || null : null,
            reportId: isPrepopulate ? editObj?.reportId || '' : '',
            issueParty: isPrepopulate
              ? editObj?.serviceProviderId || editObj?.customIssuePartyId || null
              : null,
            expiryDate: isPrepopulate ? getMomentDate(editObj?.expiryDate) || '' : '',
            existingDocuments: [],
            newDocuments: [],
            testDate: isPrepopulate ? getMomentDate(editObj?.testDate) || undefined : undefined,
          }}
          onFinish={async (values) => {
            if (onSubmit) setLoading(true);
            let newDocumentListIds = [];
            if (newFiles?.length) {
              const uploadedFiles = await uploadFile(
                newFiles.map((obj) => obj.file),
                me?.companyId
              );
              newDocumentListIds = uploadedFiles.map((x) => x.id);
            }
            const tPayload = {
              ...values,
              testItemId,
              citationId,
              existingFiles,
              newFiles,
              newDocumentListIds,
            };
            if (isEdit || isRenew) {
              tPayload.id = editObj.id;
              if (isRenew) {
                tPayload.isRenew = true;
              }
            }
            onSubmit(
              tPayload,
              () => {
                setLoading(false);
              },
              { countryListOptions, testItemOptions: options }
            );
          }}
          form={form}
          autoComplete="off"
          layout="vertical"
          className={classes.formWrapper}>
          <div className={classes.formInner}>
            {renderFields()}
            {!hideDocument && (
              <div className={classes.documents}>
                <Document
                  disabled={isView}
                  title={`Existing ${entity} Document`}
                  documents={existingFiles.map((tId, index) => {
                    const foundDocument = [...isEditDocuments, ...existingDocuments].find(
                      (obj) => String(obj?.documentList?.id || obj?.id) === String(tId)
                    );
                    return {
                      id: tId,
                      name: foundDocument?.documentList?.name || foundDocument?.fileName || '',
                    };
                  })}
                  addEl={
                    <span
                      onClick={
                        isView
                          ? undefined
                          : () => {
                              setIsSelectExisting(true);
                            }
                      }>
                      <LinkSvg />
                      <span>Add Existing Document</span>
                    </span>
                  }
                  onDelete={handleDelete('existing')}
                />
                <Document
                  title="New Document"
                  isNew
                  documents={newFiles}
                  disabled={isView}
                  caption={
                    newFiles.length > 0 ? (
                      <>
                        To add or edit data for below document in the future, please visit{' '}
                        <span
                          onClick={() => {
                            const win = window.open('/document-management', '_blank');
                            win.focus();
                          }}>
                          Document Management
                        </span>
                        .
                      </>
                    ) : (
                      undefined
                    )
                  }
                  onDelete={handleDelete('new')}
                  addEl={
                    <span
                      onClick={
                        isView
                          ? undefined
                          : () => {
                              if (inputFileRef && inputFileRef.current) {
                                inputFileRef.current.click();
                              }
                            }
                      }>
                      <PlusCircleSvg />
                      <span>Add New Document</span>
                    </span>
                  }
                />
              </div>
            )}
          </div>
          {!isView && (
            <div className={classes.footer}>
              <AButton
                htmlType="submit"
                type="primary"
                size="large"
                className={classes.confirmBtn}
                loading={loading}>
                Confirm
              </AButton>
            </div>
          )}
        </Form>
        <input
          type="file"
          ref={inputFileRef}
          multiple
          style={{ display: 'none' }}
          onChange={(e) => {
            const tFilesObj = e.target?.files;
            const tFiles = [];
            Object.keys(tFilesObj).forEach((key) => {
              const file = tFilesObj[key];
              tFiles.push({
                id: `${new Date().getTime()}_${key}`,
                name: file.name,
                file,
              });
            });
            setNewFiles((prev) => [...prev, ...tFiles]);
          }}
        />
      </AModal>
      {contextHolder}
      {isSelectExisting && (
        <AddExistingDocumentsModal
          open
          onClose={() => {
            setIsSelectExisting(false);
          }}
          onSubmit={(items) => {
            setIsSelectExisting(false);
            setExistingFiles(items);
          }}
          existingFiles={existingFiles}
          existingDocuments={existingDocuments}
        />
      )}
    </>
  );
};

export default AddDataModal;
